import {
  CustomFieldConfig,
  ResponseFields,
} from "@dreambigger/shared/src/types";
import {
  isValidAutoComplete,
  isValidSsn,
  includesUnderscore,
} from "./validators";
import { isValidPhoneNumber } from "libphonenumber-js";

export const hasEmptyRequiredFields = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  return (
    field.fieldRequired &&
    !values[valueName] &&
    field.fieldType !== "cloudinary"
  );
};

/**
 * @deprecated This function is deprecated and will be removed in future releases.
 */
export const isInvalidAutoComplete = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  return (
    field.fieldType === "autocomplete" &&
    !field.fieldConfiguration?.autocomplete?.allowFreeInput &&
    values[valueName] &&
    !isValidAutoComplete(values[valueName].toString(), field.fieldOptions)
  );
};

export const isInvalidPhoneNumber = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  return (
    field.fieldType === "phone" &&
    values[valueName] &&
    !isValidPhoneNumber(values[valueName].toString(), "US")
  );
};

export const isInvalidMaskedInput = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  return (
    field.fieldType === "maskedInput" &&
    includesUnderscore(values[valueName].toString())
  );
};

export const isInvalidSsn = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  return (
    field.fieldType === "ssn" &&
    values[valueName] &&
    !isValidSsn(values[valueName].toString())
  );
};

export const isInvalidPrivacyMaskedInput = (
  field: CustomFieldConfig,
  values: ResponseFields,
  valueName: string
) => {
  if (field.fieldType !== "privacyMaskedInput") return false;

  const value = values[valueName];
  if (!value) return false;

  const valueStr = value.toString();

  // Check if fieldMask exists and value length matches mask (user has finished typing)
  if (!field.fieldMask || valueStr.length !== field.fieldMask.length)
    return true;

  // If regex validation is provided, validate against it
  if (field.fieldRegexValidation?.regex) {
    try {
      const regex = new RegExp(field.fieldRegexValidation.regex);
      if (!regex.test(valueStr)) return true;
    } catch (regexError) {
      // If regex is invalid, log error and skip regex validation
      console.error(
        "Invalid regex pattern in fieldRegexValidation:",
        field.fieldRegexValidation.regex,
        regexError
      );
      // Don't block on invalid regex - allow the field to be valid
      return false;
    }
  }

  return false;
};
